import styled from '@emotion/styled'
import { HTMLAttributes, PropsWithChildren } from 'react'
import { joinClasses } from './joinClasses'

const ExtranetTableExpansionRoot = styled.div<{ isExpanded: boolean }>`
  max-height: ${({ isExpanded }) => (isExpanded ? 'fit-content' : '0px')};
`

type ExtranetTableExpansionProps = {
  isExpanded?: boolean
} & PropsWithChildren &
  HTMLAttributes<HTMLDivElement>

export const ExtranetTableExpansion = ({
  children,
  className,
  isExpanded,
  ...props
}: ExtranetTableExpansionProps) => {
  return (
    <ExtranetTableExpansionRoot
      className={joinClasses('entable__expansion-row', className)}
      isExpanded={!!isExpanded}
      {...props}
    >
      {children}
    </ExtranetTableExpansionRoot>
  )
}
